import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { formatNumber, formatPct } from "./d2cFormat";

// Website bike orders -> held -> offered -> accepted -> delivered, as bars
// scaled to the number of website bike orders.
const Funnel = ({ headline }) => {
  const h = headline || {};
  const steps = [
    { label: "Website bike orders", value: h.website_bike_orders },
    { label: "Held for dealers", value: h.held },
    { label: "Offered to dealers", value: h.offered, note: `${formatPct(h.offered_pct)} offered` },
    { label: "Accepted by a dealer", value: h.accepted, note: `${formatPct(h.acceptance_rate)} acceptance` },
    { label: "Delivered", value: h.delivered, note: `${formatPct(h.fulfilment_rate)} fulfilment` },
  ];
  const max = Math.max(0, ...steps.map((step) => Number(step.value) || 0));

  return (
    <Card>
      <CardHeader>
        <div>
          <CardTitle>Funnel</CardTitle>
          <CardDescription>From website order to delivery.</CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <ul className="tw-m-0 tw-list-none tw-space-y-3 tw-p-0">
          {steps.map((step, index) => {
            const value = Number(step.value) || 0;
            return (
              <li key={step.label}>
                <div className="tw-mb-1 tw-flex tw-items-baseline tw-justify-between tw-gap-2 tw-text-sm">
                  <span className="tw-text-foreground">{step.label}</span>
                  <span className="tw-whitespace-nowrap tw-font-medium tw-tabular-nums">
                    {formatNumber(step.value)}
                    {step.note && <span className="tw-ml-1.5 tw-text-xs tw-font-normal tw-text-muted-foreground">{step.note}</span>}
                  </span>
                </div>
                <div className="tw-h-2 tw-overflow-hidden tw-rounded-full tw-bg-muted">
                  <div
                    className={index === steps.length - 1 ? "tw-h-full tw-rounded-full tw-bg-emerald-500" : "tw-h-full tw-rounded-full tw-bg-primary"}
                    style={{ width: max ? `${(value / max) * 100}%` : 0, opacity: 1 - index * 0.12 }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
};

export default Funnel;
